import { Injectable } from '@angular/core';
import { InkFormData } from '@authority-labs/api-interfaces';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class InspectionDataService {
  private standardDescription = new BehaviorSubject<string>(null);
  private draftInkData = new BehaviorSubject<InkFormData>(null);

  // Observable for components to subscribe to
  $currentStandardDescription = this.standardDescription.asObservable();
  draftInkData$ = this.draftInkData.asObservable();

  setStandardDescription(newValue: string) {
    this.standardDescription.next(newValue);
  }

  setDraftInkData(data: InkFormData) {
    this.draftInkData.next(data);
  }
}
